module.exports = __webpack_public_path__ + "img/Mikel-Anakabe-Ondarre.3cf89627.png";